import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "./appActionTypes";
import { Location } from "../../interfaces/app.interface";
import appConfig from "../../appConfig";

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

async function getLocationApi(): Promise<Location> {
  console.log("getLocationApi called");

  const emptyLocation: Location = {
    latitude: 0,
    longitude: 0,
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    googleMapsData: [],
  };

  try {
    if (!navigator.geolocation) {
      console.error("Geolocation not supported");
      return emptyLocation;
    }

    // Get lat/lng
    const position = await new Promise<GeolocationPosition>(
      (resolve, reject) => {
        console.log("Requesting current position...");
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            console.log("Position retrieved:", pos.coords);
            resolve(pos);
          },
          (err) => {
            console.error("Error retrieving position:", err);
            reject(err);
          }
        );
      }
    );

    const latitude = position.coords.latitude || 0;
    const longitude = position.coords.longitude || 0;

    console.log("Fetching address info from Maps API...");

    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${appConfig.GOOGLE_MAPS_API_KEY}`
    );

    const data = await response.json();

    if (data.status !== "OK") {
      console.error("Error fetching address info:", data);
      return { ...emptyLocation, latitude, longitude };
    }

    const addressComponents = data.results[0]?.address_components || [];
    const formattedAddress = data.results[0]?.formatted_address || "";

    const location: Location = {
      latitude,
      longitude,
      address: formattedAddress || "",
      city:
        addressComponents.find((c: AddressComponent) =>
          c.types.includes("locality")
        )?.long_name || "",
      state:
        addressComponents.find((c: AddressComponent) =>
          c.types.includes("administrative_area_level_1")
        )?.long_name || "",
      country:
        addressComponents.find((c: AddressComponent) =>
          c.types.includes("country")
        )?.long_name || "",
      postalCode:
        addressComponents.find((c: AddressComponent) =>
          c.types.includes("postal_code")
        )?.long_name || "",
      googleMapsData: data.results || [],
    };

    console.log("Location info:", location);
    return location;
  } catch (error) {
    console.error("Unexpected error in getLocationApi:", error);
    return emptyLocation;
  }
}

function* fetchLocationSaga() {
  try {
    const location: Location = yield call(getLocationApi);
    yield put({ type: actionTypes.FETCH_LOCATION_SUCCESS, payload: location });
  } catch (error: any) {
    yield put({
      type: actionTypes.FETCH_LOCATION_FAILURE,
      payload: error.message,
    });
  }
}

export default function* appSaga() {
  yield takeLatest(actionTypes.FETCH_LOCATION, fetchLocationSaga);
}
